module.exports = __webpack_public_path__ + "img/create-order-logo.48796e07.svg";